function xvGetVisibleProductImage(productForm) {
  const scopes = [
    productForm.closest('.card-wrapper'),
    productForm.closest('.card'),
    productForm.closest('product-info'),
    productForm.closest('quick-add-modal'),
    productForm.closest('.product'),
  ].filter(Boolean);

  const selectors = [
    '.card__media img',
    '.product__media-item.is-active img',
    '.product__media img',
    '.quick-add__product-media img',
  ];

  for (const scope of scopes) {
    for (const selector of selectors) {
      const image = Array.from(scope.querySelectorAll(selector)).find((candidate) => {
        const rect = candidate.getBoundingClientRect();
        const styles = window.getComputedStyle(candidate);
        return rect.width > 20 && rect.height > 20 && styles.display !== 'none' && styles.visibility !== 'hidden';
      });
      if (image) return image;
    }
  }

  return null;
}

function xvBumpCartIcon() {
  const cartIcon = document.querySelector('#cart-icon-bubble');
  if (!cartIcon) return;

  cartIcon.classList.remove('xv-cart-icon-bump');
  void cartIcon.offsetWidth;
  cartIcon.classList.add('xv-cart-icon-bump');
  window.setTimeout(() => cartIcon.classList.remove('xv-cart-icon-bump'), 650);
}

function xvAnimateProductToCart(productForm) {
  const cartIcon = document.querySelector('#cart-icon-bubble');
  const sourceImage = xvGetVisibleProductImage(productForm);

  if (!cartIcon || !sourceImage || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    xvBumpCartIcon();
    return;
  }

  const sourceRect = sourceImage.getBoundingClientRect();
  const cartRect = cartIcon.getBoundingClientRect();
  const startSize = Math.max(54, Math.min(96, sourceRect.width, sourceRect.height));
  const endSize = 18;
  const startLeft = sourceRect.left + sourceRect.width / 2 - startSize / 2;
  const startTop = sourceRect.top + sourceRect.height / 2 - startSize / 2;
  const targetLeft = cartRect.left + cartRect.width / 2 - endSize / 2;
  const targetTop = cartRect.top + cartRect.height / 2 - endSize / 2;
  const deltaX = targetLeft - startLeft;
  const deltaY = targetTop - startTop;
  const arc = Math.min(130, Math.max(55, Math.abs(deltaX) * 0.12));

  const flyer = sourceImage.cloneNode(true);
  flyer.removeAttribute('id');
  flyer.removeAttribute('srcset');
  flyer.removeAttribute('sizes');
  flyer.setAttribute('aria-hidden', 'true');
  flyer.className = 'xv-cart-flyer';
  Object.assign(flyer.style, {
    left: `${startLeft}px`,
    top: `${startTop}px`,
    width: `${startSize}px`,
    height: `${startSize}px`,
  });
  document.body.appendChild(flyer);

  const animation = flyer.animate(
    [
      {
        transform: 'translate3d(0, 0, 0) scale(1)',
        opacity: 0.98,
      },
      {
        transform: `translate3d(${deltaX * 0.58}px, ${deltaY * 0.48 - arc}px, 0) scale(0.66)`,
        opacity: 0.92,
        offset: 0.58,
      },
      {
        transform: `translate3d(${deltaX}px, ${deltaY}px, 0) scale(${endSize / startSize})`,
        opacity: 0.25,
      },
    ],
    {
      duration: 720,
      easing: 'cubic-bezier(0.22, 0.72, 0.18, 1)',
      fill: 'forwards',
    }
  );

  animation.finished
    .catch(() => {})
    .finally(() => {
      flyer.remove();
      xvBumpCartIcon();
    });
}

function xvRenderCartIcon(sectionHTML) {
  if (!sectionHTML) return;

  const cartIcon = document.querySelector('#cart-icon-bubble');
  const parsedSection = new DOMParser().parseFromString(sectionHTML, 'text/html');
  const replacement = parsedSection.querySelector('#cart-icon-bubble');
  if (cartIcon && replacement) cartIcon.innerHTML = replacement.innerHTML;
}

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          this.cart.setActiveElement(document.activeElement);
        } else {
          formData.append('sections', 'cart-icon-bubble');
        }
        formData.append('sections_url', window.location.pathname);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            xvAnimateProductToCart(this);
            if (!this.cart) xvRenderCartIcon(response.sections?.['cart-icon-bubble']);

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
